import React from "react";
export function Footer() {
  return <footer className="bg-[#040C1A] px-4 pb-32 pt-10 text-center text-white/60 sm:px-6" data-id="element-133" data-mp="32wmqrybuniwl">
      <p className="font-display text-lg font-extrabold text-white" data-id="element-134" data-mp="3ggty8ibanj58">CAN Bus Diagnostic Blueprint™</p>
      <p className="mt-1 text-sm" data-id="element-135" data-mp="32pfeuadh5fxn">Created by Jason Mitchell</p>
      <p className="mt-1 text-sm" data-id="element-136" data-mp="36oy05797jt10">A practical framework for organizing automotive CAN Bus investigations.</p>
      <p className="mt-6 text-xs" data-id="element-137" data-mp="3uesbtlhsjbjo">© 2026 CAN Bus Diagnostic Blueprint™. All rights reserved.</p>
    </footer>;
}